import { useQuery } from "@tanstack/react-query";
import OCGatewayClient from "../client/OCGatewayClient";
import { gatewayUserScopedQueryOptions } from "./gatewayQueryUtils";

export function useGetUserStarredEventQuery(deviceId: string, eventId: number) {
    const query = useQuery({
        queryKey: ['getUserStarredEvent', deviceId, eventId],
        enabled: !!deviceId && !!eventId,
        queryFn: async (): Promise<{ isStarred: boolean }> => {
            return OCGatewayClient.request('getUserStarredEvent', {
                deviceId,
                eventId
            }) as Promise<{ isStarred: boolean }>;
        },
        ...gatewayUserScopedQueryOptions,
        staleTime: 1000 * 60 * 5, // 5 minutes
    });

    return query;
}
